// src/pages/admin/CreateEditQuestionnaireTemplatePage.js
// UPDATED - June 29, 2025

import React, { useState } from 'react';
import {
    Box, Paper, Typography, Button, TextField, Select, MenuItem,
    FormControl, InputLabel, DialogActions
} from '@mui/material';
import { toast } from 'react-toastify';

const CreateEditUserAgreementPage = ({ agreement, onSave, onClose }) => {
    
    // --- STATE MANAGEMENT ---
    const [title, setTitle] = useState(agreement?.title || '');
    const [version, setVersion] = useState(agreement?.version || '1.0');
    const [content, setContent] = useState(agreement?.content || '');
    // For the boolean 'active', we check if an agreement exists. If not, default to 'true' for create mode.
    const [isActive, setIsActive] = useState(agreement ? agreement.active : true);

    // src/pages/admin/CreateEditUserAgreementPage.js

    // --- SAVE HANDLER ---
    const handleSave = () => {
        // Basic Validation
        if (!title.trim() || !version.trim()) {
            toast.error("Agreement Title and Version are required.");
            return;
        }

        const agreementData = {
            title: title,
            version: version,
            content: content,
            active: isActive,
        };
        
        // Call the onSave prop passed from the parent component
        onSave(agreementData);
    };

    // --- RENDER LOGIC ---
    return (
        <Box component="form" noValidate autoComplete="off">
            <Paper sx={{ p: 3 }} variant="outlined">
                <Typography variant="h6" gutterBottom>
                    Agreement Details
                </Typography>
                <TextField
                    label="Agreement Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                />
                <TextField
                    label="Version"
                    value={version}
                    onChange={(e) => setVersion(e.target.value)}
                    fullWidth
                    required
                    sx={{ mb: 2 }}
                />
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={isActive}
                        label="Status"
                        onChange={(e) => setIsActive(e.target.value)}
                    >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>Archived</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label="Agreement Content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    fullWidth
                    required
                    multiline
                    rows={15}
                    variant="outlined"
                    placeholder="Paste the full text of the user agreement here."
                />
            </Paper>

            <DialogActions sx={{ p: '16px 0', mt: 2 }}>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSave}>
                    {agreement?.id ? 'Save Changes' : 'Create & Save Agreement'}
                </Button>
            </DialogActions>
        </Box>
);
};

export default CreateEditUserAgreementPage;